export const stageZhCN = {
  stage: {
    currentScene: '当前场景',
    generating: '生成中...',
    paused: '已暂停',
    generationFailed: '生成失败',
    confirmSwitchTitle: '切换页面',
    confirmSwitchMessage: '当前话题正在进行中，切换页面将结束当前话题。确定要切换吗？',
    generatingNextPage: '场景正在生成，请稍候...',
  },
  whiteboard: {
    title: '互动白板',
    open: '打开白板',
    clear: '清空白板',
    minimize: '最小化白板',
    ready: '白板已就绪',
    readyHint: 'AI 添加元素后将在此显示',
    clearSuccess: '白板已清空',
    clearError: '清空白板失败：',
    resetView: '重置视图',
    zoomHint: '滚轮缩放 · 拖拽平移',
    restoreError: '恢复白板失败：',
    history: '历史记录',
    restore: '恢复',
    beforeClear: '清除前',
    beforeAIClear: 'AI 清除前',
    noHistory: '暂无历史记录',
    restored: '已恢复白板内容',
    elementCount: '{count} 个元素',
  },
  quiz: {
    title: '随堂测验',
    subtitle: '检测你的学习成果',
    questionsCount: '道题',
    totalPrefix: '共',
    pointsSuffix: '分',
    startQuiz: '开始答题',
    multipleChoiceHint: '（多选题，请选择所有正确答案）',
    inputPlaceholder: '请在此输入你的回答...',
    charCount: '字',
    yourAnswer: '你的回答：',
    notAnswered: '未作答',
    aiComment: 'AI 点评',
    singleChoice: '单选',
    multipleChoice: '多选',
    shortAnswer: '简答',
    analysis: '解析：',
    excellent: '优秀！',
    keepGoing: '继续加油！',
    needsReview: '需要复习',
    correct: '正确',
    incorrect: '错误',
    answering: '答题中',
    submitAnswers: '提交答案',
    aiGrading: 'AI 正在批改中...',
    aiGradingWait: '请稍候，正在分析你的答案',
    quizReport: '答题报告',
    retry: '重新答题',
  },
  roundtable: {
    teacher: '教师',
    you: '你',
    inputPlaceholder: '输入你的消息...',
    listening: '录音中...',
    processing: '处理中...',
    noSpeechDetected: '未检测到语音，请重试',
    discussionEnded: '讨论已结束',
    qaEnded: '问答已结束',
    thinking: '思考中',
    yourTurn: '轮到你发言了',
    stopDiscussion: '结束讨论',
    autoPlay: '自动播放',
    autoPlayOff: '关闭自动播放',
    speed: '倍速',
  },
  pbl: {
    legacyFormat: '此PBL场景使用旧格式，请重新生成课程',
    emptyProject: 'PBL项目尚未生成，请通过课程生成创建',
    roleSelection: {
      title: '选择你的角色',
      description: '选择一个角色开始项目协作',
    },
    workspace: {
      restart: '重新开始',
      confirmRestart: '确定重置进度？',
      confirm: '确定',
      cancel: '取消',
    },
    issueboard: {
      title: '任务看板',
      noIssues: '暂无任务',
      statusDone: '已完成',
      statusActive: '进行中',
      statusPending: '待处理',
    },
    chat: {
      title: '项目讨论',
      currentIssue: '当前任务',
      mentionHint: '使用 @question 提问，@judge 提交评审',
      placeholder: '输入消息...',
      send: '发送',
      welcomeMessage:
        '你好！我是本任务的提问助手，当前任务：「{title}」\n\n为了帮助你开展工作，我准备了一些引导问题：\n\n{questions}\n\n随时可以 @question 向我提问！',
      issueCompleteMessage: '任务「{completed}」已完成！进入下一个任务：「{next}」',
      allCompleteMessage: '🎉 所有任务都已完成！项目做得很棒！',
    },
    guide: {
      howItWorks: '如何参与项目',
      help: '使用帮助',
      title: '使用帮助',
      step1: {
        title: '第一步：选择角色',
        desc: '项目生成后，从角色列表中选择一个角色（标记为🟢的非系统角色）',
      },
      step2: {
        title: '第二步：完成任务',
        desc: '每个任务代表一个学习目标：',
        s1: {
          title: '查看当前任务',
          desc: '查看任务的标题、描述、负责人',
        },
        s2: {
          title: '获取指导',
          example: '@question 我应该从哪里开始？\n@question 如何实现这个功能？',
          desc: '提问助手会提供引导性问题和提示（不直接给答案）',
        },
        s3: {
          title: '提交作品',
          example: '@judge 我已经完成了，请检查',
          desc: '评审助手会评估你的工作并给出反馈：',
          complete: '自动进入下一个任务',
          revision: '根据反馈改进',
        },
      },
      step3: {
        title: '第三步：完成项目',
        desc: '所有任务完成后，系统会显示「🎉 项目已完成！」',
      },
    },
  },
  share: {
    notReady: '生成完成后可分享',
  },
} as const;

export const stageEnUS = {
  stage: {
    currentScene: 'Current Scene',
    generating: 'Generating...',
    paused: 'Paused',
    generationFailed: 'Generation failed',
    confirmSwitchTitle: 'Switch Scene',
    confirmSwitchMessage:
      'A topic is currently in progress. Switching scenes will end the current topic. Are you sure?',
    generatingNextPage: 'Scene is being generated, please wait...',
  },
  whiteboard: {
    title: 'Interactive Whiteboard',
    open: 'Open Whiteboard',
    clear: 'Clear Whiteboard',
    minimize: 'Minimize Whiteboard',
    ready: 'Whiteboard is ready',
    readyHint: 'Elements will appear here when added by AI',
    clearSuccess: 'Whiteboard cleared successfully',
    clearError: 'Failed to clear whiteboard: ',
    resetView: 'Reset View',
    zoomHint: 'Scroll to zoom · Drag to pan',
    restoreError: 'Failed to restore whiteboard: ',
    history: 'History',
    restore: 'Restore',
    beforeClear: 'Before clear',
    beforeAIClear: 'Before AI clear',
    noHistory: 'No history yet',
    restored: 'Whiteboard restored',
    elementCount: '{count} elements',
  },
  quiz: {
    title: 'Quiz',
    subtitle: 'Test your knowledge',
    questionsCount: 'questions',
    totalPrefix: '',
    pointsSuffix: 'pts',
    startQuiz: 'Start Quiz',
    multipleChoiceHint: '(Multiple choice — select all correct answers)',
    inputPlaceholder: 'Type your answer here...',
    charCount: 'chars',
    yourAnswer: 'Your answer:',
    notAnswered: 'Not answered',
    aiComment: 'AI Feedback',
    singleChoice: 'Single',
    multipleChoice: 'Multiple',
    shortAnswer: 'Short answer',
    analysis: 'Analysis: ',
    excellent: 'Excellent!',
    keepGoing: 'Keep going!',
    needsReview: 'Needs review',
    correct: 'correct',
    incorrect: 'incorrect',
    answering: 'In Progress',
    submitAnswers: 'Submit Answers',
    aiGrading: 'AI is grading...',
    aiGradingWait: 'Please wait, analyzing your answers',
    quizReport: 'Quiz Report',
    retry: 'Retry',
  },
  roundtable: {
    teacher: 'TEACHER',
    you: 'YOU',
    inputPlaceholder: 'Type your message...',
    listening: 'Listening...',
    processing: 'Processing...',
    noSpeechDetected: 'No speech detected, please try again',
    discussionEnded: 'Discussion ended',
    qaEnded: 'Q&A ended',
    thinking: 'Thinking',
    yourTurn: 'Your turn',
    stopDiscussion: 'Stop Discussion',
    autoPlay: 'Auto-play',
    autoPlayOff: 'Stop auto-play',
    speed: 'Speed',
  },
  pbl: {
    legacyFormat: 'This PBL scene uses a legacy format. Please regenerate the course.',
    emptyProject: 'PBL project has not been generated yet. Please create via course generation.',
    roleSelection: {
      title: 'Choose Your Role',
      description: 'Select a role to start collaborating on the project',
    },
    workspace: {
      restart: 'Restart',
      confirmRestart: 'Reset all progress?',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    issueboard: {
      title: 'Issue Board',
      noIssues: 'No issues yet',
      statusDone: 'Done',
      statusActive: 'Active',
      statusPending: 'Pending',
    },
    chat: {
      title: 'Project Discussion',
      currentIssue: 'Current Issue',
      mentionHint: 'Use @question to ask, @judge to submit for review',
      placeholder: 'Type a message...',
      send: 'Send',
      welcomeMessage:
        'Hello! I\'m your Question Agent for this issue: "{title}"\n\nTo help guide your work, I\'ve prepared some questions for you:\n\n{questions}\n\nFeel free to @question me anytime if you need help or clarification!',
      issueCompleteMessage: 'Issue "{completed}" completed! Moving to next issue: "{next}"',
      allCompleteMessage: '🎉 All issues completed! Great work on the project!',
    },
    guide: {
      howItWorks: 'How it works',
      help: 'Help',
      title: 'Help',
      step1: {
        title: 'Step 1: Choose a Role',
        desc: 'After the project is generated, select a role from the list (non-system roles marked with 🟢)',
      },
      step2: {
        title: 'Step 2: Complete Issues',
        desc: 'Each issue represents a learning task:',
        s1: {
          title: 'View current Issue',
          desc: "Check the issue's title, description, and assignee",
        },
        s2: {
          title: 'Get guidance',
          example: '@question Where should I start?\n@question How do I implement this feature?',
          desc: 'The Question Agent provides guiding questions and hints (no direct answers)',
        },
        s3: {
          title: 'Submit your work',
          example: "@judge I'm done, please check my Notes",
          desc: 'The Judge Agent evaluates your work and gives feedback:',
          complete: 'Automatically moves to the next issue',
          revision: 'Improve based on feedback',
        },
      },
      step3: {
        title: 'Step 3: Complete the Project',
        desc: 'When all issues are done, the system displays "🎉 Project Complete!"',
      },
    },
  },
  share: {
    notReady: 'Available after generation completes',
  },
} as const;
